<div class="mode-wrapper {{ uiMode() }}">
  <div class="mode-variant-wrapper {{ modeVariantClass() }}">
    <scope-theme />
    <app-stencil-navbar id="scope-navbar-top-menu" />
    <app-stencil-side-menu (expandedStateChanged)="sideMenuStateChanged($event)">
      <main>
        <app-announcement-banner />

        <div class="content-wrapper" [ngClass]="{ 'content-wrapper--width': !unlimitedWidthRoutes() }">
          <router-outlet />
          @if (showNotificationPopup()) {
            <app-notification-popup [message]="message()" (closePopup)="closePopup()" />
          }
        </div>
        @if (languageCode()) {
          <scope-footer
            class="scope-footer-override"
            [class.scope-legal-footer-map]="isMapRoute()"
            culturecode="{{ languageCode() }}"
            market="{customerMarket}"
          >
            <div class="scope-legal-footer-item">
              <button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie settings</button>
            </div>
          </scope-footer>
        }
      </main>
    </app-stencil-side-menu>
  </div>
  <div id="widget-container">
    @if (languageCode().length > 0) {
      <app-zendesk />
    }
  </div>
</div>
